module.exports = __webpack_public_path__ + "images/traditional-1-b0b14e46c789c5cfbf34e1fc0ca352b7.jpg";